<style scoped lang="scss">
.page-maintenance-day-statistics {
    .work-days {
        display: flex;
        justify-content: flex-start;
        .totals {
            flex: 1;
            max-width: 50px;
        }
        .details {
            flex: 2;
        }
    }
}
/deep/ .page-statisticstologs-dialog {
    margin-top: 5vh !important;
    width: 96%;
    height: auto;
}
</style>

<template>
  <div class="page-maintenance-day-statistics">
    <div class="toolbars mrgb5">
        <div class="buttons mrgb5">
            <div class="fl">
              <el-button-group class="mrgr5 mrgb5">
                  <el-button :class="$root.isPc ? '' : 'mobile-group-button'" type="primary" v-for="(tab, index) in tabs" :plain="tabIndex !== index"
                      :key="'employee_tab_' + index" size="medium" @click="tabClick(index)">{{ tab }}</el-button>
              </el-button-group>
              <el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium" v-show="isShowSelectTime"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>
            </div>
            <div class="fr">
                <span class="mrgr5 mrgb5">
                    <el-checkbox v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="serviceAreaChange"></el-checkbox>
                </span>
                <el-input class="c-el-input mrgr5 mrgb5" placeholder="员工的姓名/手机号" clearable v-model="listQuery.keywords"
                    size="medium"></el-input>
                <!--<el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>-->
                <el-button type="primary" size="medium" @click="_search()"><i class="fa fa-search"></i> 查询</el-button>
                <el-button class="mrgb5" type="warning" size="medium" @click="openExportExcel()"><i class="fa fa-sign-out"></i> 导出</el-button>
            </div>
            <div class="clearb"></div>
        </div>
    </div>
    <el-table :data="tableData" style="width: 100%" border size="medium">
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="联系电话" prop="tel"></el-table-column>
        <el-table-column label="归属平台" prop="platform"></el-table-column>
        <el-table-column label="归属服务区" prop="serviceName"></el-table-column>
        <el-table-column label="工作天数" prop="workDays" min-width="200">
            <template slot-scope="scope">
                <div class="work-days">
                    <div class="totals">
                        <el-tag type="danger" size="small" class="fwb">{{ scope.row.workDays }}天</el-tag>
                        <el-tooltip effect="dark" placement="left" content="查看工作过的服务区" v-if="isOperationMoveTask || isOperationBatteryChangeTask || isOperationMaintenanceLog">
                            <el-tag type="primary" size="mini" class="mrgt5 curp" effect="light"
                                @click="showWorkedServiceAreas(scope.row)">
                                <i class="el-icon-more f14"></i>
                            </el-tag>
                        </el-tooltip>
                    </div>
                    <div class="details">
                        <el-tag type="info" size="small" class="mrgb5 mrgr5" effect="plain">
                            小于4小时：
                            <span class="fwb">{{ scope.row.workL4Days }}</span>
                        </el-tag>
                        <el-tag type="info" size="small" class="mrgb5 mrgr5" effect="plain">
                            小于8小时：
                            <span class="fwb">{{ scope.row.workL8Days }}</span>
                        </el-tag>
                        <el-tag type="success" size="small" class="mrgb5 mrgr5" effect="plain">
                            大于8小时：
                            <span class="fwb">{{ scope.row.workG8Days }}</span>
                        </el-tag>
                        <el-tag type="warning" size="small" class="mrgb5 mrgr5" effect="plain">
                            大于10小时：
                            <span class="fwb">{{ scope.row.workG10Days }}</span>
                        </el-tag>
                        <el-tag type="danger" size="small" class="mrgb5 mrgr5" effect="plain">
                            大于12小时：
                            <span class="fwb">{{ scope.row.workG12Days }}</span>
                        </el-tag>
                    </div>
                </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="正常" prop="normal"></el-table-column> -->
        <el-table-column label="有效挪车量" prop="moveCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="有效挪车量">
                    <span class="col_primary fwb" @click="showMoveData(scope.row, 1)">{{ scope.row.moveCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="有效换电量" prop="batteryChangeCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="有效换电量">
                    <span class="col_success fwb" @click="showBatteryData(scope.row, 1)">{{ scope.row.batteryChangeCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="有效维修量" prop="reparionCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="有效维修量">
                    <span class="col_danger fwb" @click="showRepairData(scope.row, 1)">{{ scope.row.reparionCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <!-- <el-table-column label="巡检量" prop="inspectionCount"></el-table-column> -->
        <el-table-column label="扫一扫" prop="scanCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="扫一扫">
                    <span class="col_warning fwb">{{ scope.row.scanCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="绩效" prop="performance">
            <template slot-scope="scope">
                <el-tag type="info" size="small" class="mrgb5 mrgr5" effect="light" v-if="scope.row.performance <= 0">
                    {{ scope.row.performance }}
                </el-tag>
                <el-tag type="danger" size="small" class="mrgb5 mrgr5" effect="light" v-else-if="scope.row.performance < 10">
                    {{ scope.row.performance }}
                </el-tag>
                <el-tag type="warning" size="small" class="mrgb5 mrgr5" effect="light" v-else-if="scope.row.performance < 20">
                    {{ scope.row.performance }}
                </el-tag>
                <el-tag type="success" size="small" class="mrgb5 mrgr5" effect="light" v-else>
                    {{ scope.row.performance }}
                </el-tag>
            </template>
        </el-table-column>
        <!-- <el-table-column label="未审核" prop="unHandled">
            <template slot-scope="scope">
                <el-tag class="curp" type="danger" size="small" effect="dark" v-if="scope.row.unHandled > 0"
                    @click="_detail(scope.row, false)">{{ scope.row.unHandled }}</el-tag>
                <span v-else>{{ scope.row.unHandled }}</span>
            </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" width="120" fixed="right">
            <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="_detail(scope.row)">工作记录</el-button>
            </template>
        </el-table-column>
    </el-table>

    <el-dialog :title="logTitle" custom-class="c-el-dialog page-statisticstologs-dialog" :append-to-body="true"
        :visible.sync="showLogsDialog" :before-close="_closeLogs" :close-on-click-modal="false">
        <day-works :ref="refToWorks"></day-works>
    </el-dialog>

    <!--员工工作数据-->
    <el-dialog :title="dialogTitle" :fullscreen="true" :append-to-body="true"
        :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false">
        <!--员工挪车数据-->
        <member-move-data :ref="refMemberMoveData" v-if="showDialogType === 1"></member-move-data>
        <!--员工换电数据-->
        <member-battery-data :ref="refMemberBatteryData" v-if="showDialogType === 2"></member-battery-data>
        <!--员工维修数据-->
        <member-repair-data :ref="refMemberRepairData" v-if="showDialogType === 3"></member-repair-data>
    </el-dialog>

    <!-- 工作服务区域 -->
    <work-service-areas :ref="refWorkAreas"></work-service-areas>
  </div>
</template>

<script>
  import permission from "@/mixins/permission"
  import enumConfigs from "@/mixins/enumConfigs"
  import * as funEmployees from '@/api/employees'
  import moment from "moment"
  import DayWorks from "./dayWorks"
  import WorkServiceAreas from "./components/workServiceAreas"
  import MemberMoveData from "@/views/admin/employees/moveData"
  import MemberBatteryData from "@/views/admin/employees/batteryData"
  import MemberRepairData from "@/views/admin/employees/maintenanceData"
  import { DayWorkStatistics } from "@/mixins/commonPageExport"
  export default {
    name: "pageMaintenanceDayStatistics",
    mixins: [permission, enumConfigs],
    components: { DayWorks, WorkServiceAreas, MemberMoveData, MemberBatteryData, MemberRepairData },
    data() {
      let that = this
      return {
        refToWorks: "refStatisticeToWorks",
        refWorkAreas: "refWorkServiceAreas",
        refMemberMoveData: "refDayStatisticsMemberMoveData",
        refMemberBatteryData: "refDayStatisticsMemberBatteryData",
        refMemberRepairData: "refDayStatisticsMemberRepairData",
        tableData: [],
        listQuery: {
            isFilterArea: false,
            platform: "",
            area: "",
            keywords: "",
            startDate: "",
            endDate: ""
        },
        selectedTime: [],
        pickerOptions: {
            shortcuts: [
                {
                    text: "昨天",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "days")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一周",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "weeks")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近三月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 3, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近半年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 6, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "years")
                        that.setQueryTime(timeArr)
                    }
                }
            ]
        },
        tabIndex: 0,
        tabs: ["昨日", "本月", "上月", "自定义"],
        isShowSelectTime: false,
        showLogsDialog: false,
        logTitle: "",
        dialogTitle: "",
        showDialog: false,
        showDialogType: 0
      }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.serviceAreaChange(this.listQuery.isFilterArea)
            })
        }
    },
    mounted() {
        this.tabClick(0)
    },
    methods: {
        // 重写本页的时间范围的快捷筛选，设置时间
        setPickerTime(picker, spaceTime, dateStr, isStartOf) {
            let timeArr = []
            let startTime = null
            let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
            startTime = moment().subtract(spaceTime, dateStr).format("YYYY-MM-DD 00:00:00")
            startTime = moment(startTime).format("YYYY-MM-DD 00:00:00")
            timeArr = [startTime, endTime]
            if (picker) {
                picker.$emit('pick', timeArr);
            }
            return timeArr
        },
        setQueryTime(timeArr) {
            this.listQuery.startDate = timeArr[0] || ""
            this.listQuery.endDate = timeArr[1] || ""
        },
        setSelectedTime() {
            let psTime = ""
            let peTime = ""
            if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
                psTime = moment(this.selectedTime[0]).format("YYYY-MM-DD HH:mm:ss")
            }
            if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
                peTime = moment(this.selectedTime[1]).format("YYYY-MM-DD HH:mm:ss")
            }
            this.listQuery.startDate = psTime
            this.listQuery.endDate = peTime
            this.selectedTime = [this.listQuery.startDate, this.listQuery.endDate]
        },
        getDataList () {
            this.setSelectedTime()
            window.$common.fullLoading()
            this.tableData = []
            this.listQuery.area = this.listQuery.isFilterArea ? this.$store.getters.serviceArea : ""
            this.listQuery.keywords = this.listQuery.keywords.trim()
            funEmployees.DayWorkStatistics(this.listQuery).then(response => {
                window.$common.closeFullLoading()
                if (response && response.length > 0) {
                    this.tableData = response.map(x => {
                        return x
                    })
                } else {
                    this.tableData = []
                }
            })
        },
        serviceAreaChange(val) {
            if (val === true) {
                this.listQuery.platform = this.$store.getters.servicePlatform || ""
                this.listQuery.area = this.$store.getters.serviceArea || ""
            } else {
                this.listQuery.platform = ""
                this.listQuery.area = ""
            }
            this._search()
        },
        tabClick(index) {
            this.tabIndex = index
            switch(index) {
                case 0: {
                    let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
                    this.selectedTime = [moment(endTime).format("YYYY-MM-DD 00:00:00"), endTime]
                    break
                }
                case 1: {
                    this.selectedTime = [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")]
                    break
                }
                case 2: {
                    this.selectedTime = [moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD 00:00:00"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD 23:59:59")]
                    break
                }
            }
            if (index !== 3) {
                this.isShowSelectTime = false
                this._search()
            } else {
                this.selectedTime = []
                this.isShowSelectTime = true
                this.tableData = []
            }
        },
        showWorkedServiceAreas(row) {
            let params = {
                name: row.name,
                telOrName: row.tel,
                beginDate: this.listQuery.startDate,
                endDate: this.listQuery.endDate
            }
            this.$refs[this.refWorkAreas].open(params)
        },
        showMoveData(row, type) {
            if (!this.isOperationMoveTask) {
                this.warningMsg("暂无权限查看挪车记录")
                return false
            }
            this.dialogTitle = `【${row.name} | ${row.tel}】的挪车记录`
            this.showDialog = true
            this.showDialogType = 1
            setTimeout(() => {
                this.$refs[this.refMemberMoveData].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    telOrName: row.name, 
                    selectedTime: [this.listQuery.startDate, this.listQuery.endDate],
                    type,
                    tabIndex: 3
                })
            }, 100)
        },
        showBatteryData(row, type) {
            if (!this.isOperationBatteryChangeTask) {
                this.warningMsg("暂无权限查看换电记录")
                return false
            }
            this.dialogTitle = `【${row.name} | ${row.tel}】的换电记录`
            this.showDialog = true
            this.showDialogType = 2
            setTimeout(() => {
                this.$refs[this.refMemberBatteryData].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    telOrName: row.name, 
                    selectedTime: [this.listQuery.startDate, this.listQuery.endDate],
                    type,
                    tabIndex: 3
                })
            }, 100)
        },
        showRepairData(row, type) {
            if (!this.isOperationMaintenanceLog) {
                this.warningMsg("暂无权限查看维修记录")
                return false
            }
            this.dialogTitle = `【${row.name} | ${row.tel}】的维修记录`
            this.showDialog = true
            this.showDialogType = 3
            setTimeout(() => {
                this.$refs[this.refMemberRepairData].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    telOrName: row.name, 
                    selectedTime: [this.listQuery.startDate, this.listQuery.endDate],
                    type,
                    tabIndex: 3
                })
            }, 100)
        },
        navTo(row) {
            this.$router.push({ name: "pageMaintenanceDayWorks", params: { keyword: row.tel, selectedTime: this.selectedTime } })
        },
        _detail(row) {
            this.logTitle = `【${row.name}】的工作记录`
            this.showLogsDialog = true
            setTimeout(() => {
                this.$refs[this.refToWorks].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    keyword: row.tel, 
                    selectedTime: this.selectedTime,
                    tabIndex: this.tabIndex
                })
            }, 100)
        },
        _closeLogs() {
            this.showLogsDialog = false
        },
        _close() {
            if (this.showDialogType === 1) {
                this.$refs[this.refMemberMoveData].close()
            } else if (this.showDialogType === 2) {
                this.$refs[this.refMemberBatteryData].close()
            } else if (this.showDialogType === 3) {
                this.$refs[this.refMemberRepairData].close()
            }
            this.showDialog = false
            this.showDialogType = 0
        },
        _search() {
            this.getDataList()
        },
        openExportExcel() {
            window.$common.fullLoading()
            this.setSelectedTime()
            this.listQuery.area = this.listQuery.isFilterArea ? this.$store.getters.serviceArea : ""
            this.listQuery.keywords = this.listQuery.keywords.trim()
            funEmployees.DayWorkStatistics(this.listQuery).then(response => {
                window.$common.closeFullLoading()
                try {
                    if (response && response.length > 0) {
                        // 生成导出文件名
                        let exportTitle = ""
                        let exportTime = ""
                        let startDate = moment(this.listQuery.startDate).format("YYYY-MM-DD")
                        let endDate = moment(this.listQuery.endDate).format("YYYY-MM-DD")
                        if (startDate === endDate) {
                            exportTime = startDate
                        } else {
                            exportTime = `${startDate}至${endDate}`
                        }
                        exportTitle = `${this.$store.getters.serviceArea}工作统计(${exportTime}).xlsx`
                        // 调用导出函数
                        DayWorkStatistics(exportTitle, response)
                    } else {
                        setTimeout(() => {
                            this.alert("没有需要导出的数据!")
                        }, 10)
                    }
                } catch(ex) {
                    this.errorMsg("导出的数据出错!")
                    window.$common.closeFullLoading()
                }
            }).catch(() => {
                window.$common.closeFullLoading()
            })
        }
    }
  }
</script>